<template>
  <div class="big-map-box">
    <div class="map-content" id="transferMap"></div>
    <div class="map-darkcorner"></div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  name: 'Transfermap',
  props: {
    title: {
      type: String,
      default: ''
    },
    legendColor: {
      type: Array
    },
    chartData: {
      type: Object,
      default() {
        return {
        }
      }
    }
  },
  data() {
    return {
      chart: null,
      map: null
    }
  },
  mounted() {
    this.initChart()
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      // 先根据value洗颜色和symbol大小
      for (let i = 0; i < this.chartData.sourceArea.length; i++) {
        if(!this.chartData.sourceArea[i].hasOwnProperty('coordinate')) {
          continue
        }
        if (this.chartData.sourceArea[i].num >= this.chartData.legendConf[0].min) {
          this.chartData.sourceArea[i].symbolSize = 14
          this.chartData.sourceArea[i].color = this.legendColor[0]
        } else if (
          this.chartData.sourceArea[i].num >= this.chartData.legendConf[1].min
        ) {
          this.chartData.sourceArea[i].symbolSize = 12
          this.chartData.sourceArea[i].color = this.legendColor[1]
        } else if (
          this.chartData.sourceArea[i].num >= this.chartData.legendConf[2].min
        ) {
          this.chartData.sourceArea[i].symbolSize = 10
          this.chartData.sourceArea[i].color = this.legendColor[2]
        } else if (
          this.chartData.sourceArea[i].num >= this.chartData.legendConf[3].min
        ) {
          this.chartData.sourceArea[i].symbolSize = 8
          this.chartData.sourceArea[i].color = this.legendColor[3]
        } else if (
          this.chartData.sourceArea[i].num >= this.chartData.legendConf[4].min
        ) {
          this.chartData.sourceArea[i].symbolSize = 6
          this.chartData.sourceArea[i].color = this.legendColor[4]
        }
      }

      // 洗series
      var series = []
      for (let i = 0; i < this.chartData.sourceArea.length; i++) {
        if(!this.chartData.sourceArea[i].hasOwnProperty('coordinate')) {
          continue
        }
        series.push({
          name: this.chartData.sourceArea[i].name,
          coordinateSystem: 'amap',
          type: 'lines',
          zlevel: 3,
          effect: {
            show: true,
            period: 6,
            shadowBlur: 4,
            trailLength: 0.4,
            opacity: 0.4,
            color: '#cbeeff',
            symbolSize: 4
          },
          lineStyle: {
            normal: {
              color: this.chartData.sourceArea[i].color,
              width: 0,
              curveness: 0.2
            }
          },
          data: [
            {
              fromName: this.chartData.sourceArea[i].name,
              toName: this.chartData.curArea,
              coords: [
                this.chartData.curCenter,
                this.chartData.sourceArea[i].coordinate

              ],
              value: this.chartData.sourceArea[i].value
            }
          ]
        })
        series.push({
          name: this.chartData.sourceArea[i].name,
          coordinateSystem: 'amap',
          type: 'lines',
          zlevel: 2,
          lineStyle: {
            normal: {
              color: this.chartData.sourceArea[i].color,
              width: 2,
              opacity: 0.8,
              curveness: 0.2,
              shadowColor: this.chartData.sourceArea[i].color,
              shadowBlur: 10,
            }
          },
          data: [
            {
              fromName: this.chartData.sourceArea[i].name,
              toName: this.chartData.curArea,
              coords: [
                this.chartData.curCenter,
                this.chartData.sourceArea[i].coordinate
              ],
              value: this.chartData.sourceArea[i].value
            }
          ]
        })
        series.push({
          name: this.chartData.sourceArea[i].name,
          type: 'effectScatter',
          coordinateSystem: 'amap',
          zlevel: 4,
          symbol: 'circle',
          symbolSize: this.chartData.sourceArea[i].symbolSize,
          rippleEffect: {
            scale: 8,
            period: 6,
            brushType: 'fill'
          },
          label: {
            normal: {
              show: true,
              position: 'bottom',
              formatter: () => {
                return this.chartData.sourceArea[i].name + ' ' + this.chartData.sourceArea[i].num
              },
              color: '#cbeeff'
            }
          },
          itemStyle: {
            normal: {
              color: this.chartData.sourceArea[i].color
            }
          },
          data: [
            {
              name: this.chartData.sourceArea[i].name,
              value: this.chartData.sourceArea[i].coordinate
            }
          ]
        })
      }

      this.chart = this.$echarts.init(document.getElementById('transferMap'))
      this.chart.setOption({
        amap: {
          zoom: 5,
          zooms: [4, 10],
          mapStyle: 'amap://styles/b5500447492ee5d38f79824b6e68aec4',
          center: this.chartData.curCenter, //中心点
          rotation: 0, //顺时针旋转角度
          resizeEnable: true
        },
        animation: false,
        series: []
      })

      this.map = this.chart
        .getModel()
        .getComponent('amap')
        .getAMap()

      this.chart.setOption({
        series: series
      })
    }
  }
}
</script>

<style scoped lang="less">
.map-title {
  width: 4rem;
  height: 0.3rem;
  margin: 0.3rem auto 0;
  color: @light-blue;
  font-size: 0.2rem;
  font-weight: bold;
  position: relative;
  z-index: 9999;
  .tab {
    width: 3.9rem;
    height: 0.22rem;
    margin: 0.1rem auto;
    > div {
      width: 33.3333333%;
      height: 100%;
      font-size: 0.14rem;
      line-height: 0.23rem;
      color: @base-text-color;
      float: left;
      cursor: pointer;
      background: url(../../assets/spot_tab_bg.png);
      background-size: 100% 100%;
    }
    .current {
      background: url(../../assets/tab_bg_cur.png);
      background-size: 100% 100%;
    }
  }
}
</style>
